import { ENV } from 'src/global-config';
import { decryptData } from './encrypt';
import { useEffect, useState } from 'react';
import { USERE_DETAILS } from './constants';
import Script from 'next/script';

export const ZohoSalesIQ = () => {
  const [userData, setUserData] = useState({
    userName: 'Guest User From Website',
    userMobileNumber: '',
    currentLang: 'en',
  });

  useEffect(() => {
    const currentLang = localStorage.getItem('i18nextLng') || 'ar';
    const userDetails = localStorage.getItem(USERE_DETAILS);
    const decryptedUserDetails = decryptData(userDetails);
    const checkUserDetails = Object.keys(decryptedUserDetails || {}).length > 0;

    setUserData({
      userName: checkUserDetails ? decryptedUserDetails.userName : 'Guest User From Website',
      userMobileNumber: checkUserDetails ? decryptedUserDetails.mobileNumber : '',
      currentLang,
    });
  }, []);

  const widgetCode =
    ENV === 'prod'
      ? '4016996088f54b14a79a1d5fe5fac458c8666f663a0a8a1db8116f4dc731d4e9'
      : 'siq1d0834d778ae0c83e01d11e4b573bb0d';

  return (
    <>
      <Script
        id="zoho-salesiq"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
        var $zoho=$zoho || {};
        $zoho.salesiq = $zoho.salesiq || {
          widgetcode: "${widgetCode}",
          values:{},
          theme: {
            bannerColor: "#4CAF50",
            primaryColor: "#4CAF50",
            fontColor: "#ffffff",
            chatBubble: { background: "#4CAF50", color: "#ffffff" }
          },
          ready:function(){
            window.__zohoReady = true;
            $zoho.salesiq.visitor.name("${userData?.userName}");
            $zoho.salesiq.visitor.contactnumber("${userData?.userMobileNumber}");
            $zoho.salesiq.language("${userData?.currentLang}");
            $zoho.salesiq.chatbutton.position("${userData?.currentLang}" === "ar" ? "bottomleft" : "bottomright");
            $zoho.salesiq.floatbutton.visible('hide');
            $zoho.salesiq.chatbutton.visible('show');
          }
        };
        var d=document;
        var s=d.createElement("script");
        s.type="text/javascript";
        s.defer=true;
        s.src="https://salesiq.zohopublic.com/widget";
        d.body.appendChild(s);
      `,
        }}
      />
    </>
  );
};
